module.exports = __webpack_public_path__ + "AvertaStd-SemiboldItalic.svg?290691122fd37916efe9dabbbed1c4bf";